import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-bb986d58"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "header"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h1", {
  class: "header__logo"
}, "Поженимся", -1));

const _hoisted_3 = {
  class: "header__menu"
};

const _hoisted_4 = /*#__PURE__*/_createTextVNode("Выйти");

import useLogout from "@/composables/useLogout";
import { ref } from "vue";
import { useRoute } from "vue-router";
export default /*#__PURE__*/_defineComponent({
  setup(__props) {
    const route = useRoute();
    let menu = ref([{
      label: "Пользователи",
      name: "userList",
      path: "users"
    }, {
      label: "Интересы",
      name: "interestList",
      path: "interests"
    }, {
      label: "Модерация",
      name: "moderationList",
      path: "moderation"
    }, {
      label: "Подарки",
      name: "presentList",
      path: "present"
    }, {
      label: "Сторис",
      name: "storyList",
      path: "story"
    }, {
      label: "Платные функции",
      name: "paymentList",
      path: "payment"
    }, {
      label: "Уведомления",
      name: "notifyList",
      path: "notify"
    }]);
    let {
      logout
    } = useLogout();
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");

      const _component_el_button = _resolveComponent("el-button");

      return _openBlock(), _createElementBlock("header", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menu), (item, index) => {
        return _openBlock(), _createBlock(_component_router_link, {
          key: index,
          to: {
            name: item.name
          },
          class: _normalizeClass(["header__menu-item", !_unref(route).path.includes(item.path) ? 'header__menu-link' : 'header__menu-active'])
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item.label), 1)]),
          _: 2
        }, 1032, ["to", "class"]);
      }), 128))]), _createVNode(_component_el_button, {
        type: "text",
        class: "header__logout",
        onClick: _cache[0] || (_cache[0] = $event => _unref(logout)())
      }, {
        default: _withCtx(() => [_hoisted_4]),
        _: 1
      })]);
    };
  }

});